import React from 'react';
import Tabs from '@hpstellar/core/visId/Tabs';

import { withError } from '../../shared/components/error-boundary';
import useHawksearchComponent from '../useHawksearchComponent';
import SearchPageSuggestion from './search-page-suggestion';
import SearchProductCategoryTiles from './search-product-category-tiles';

import './css/search-page-header.less';

export default withError(props => {
    const { onSwitchTabs, activeIndex, tabs, searchKey, tabType, supportResults } = props || {};
    const hawksearchResults = useHawksearchComponent();
    const { supportPages } = supportResults || {};
    const { type } = hawksearchResults || {};
    const searchResults = hawksearchResults && hawksearchResults[type];
    const { Pagination, DidYouMean } = searchResults || {};
    const { NofResults } = Pagination || {};
    const isSupport = tabType === 'support';
    const zeroResults = isSupport ? supportPages && supportPages.length === 0 : NofResults === 0;
    const suggestionsAreValid = !isSupport && Array.isArray(DidYouMean) && DidYouMean.filter(s => typeof s === 'string').length > 0;

    const suggestionsComp = (
        <div className='srp-suggestions-and-categories-container'>
            <div className='srp-suggestion-and-categories'>
                <SearchPageSuggestion {...props} zeroResults={zeroResults} srpDidYouMean={suggestionsAreValid}/>
                {
                    !suggestionsAreValid && zeroResults && <SearchProductCategoryTiles searchKey={searchKey} type={tabType || type}/>
                }
            </div>
        </div>
    )
    // const zeroResultsWithoutSuggestions = zeroResults && (!suggestionsAreValid || isSupport);
    return (
        <div className='srp-header-container'>
            <div className='srp-header-section'>
                { suggestionsAreValid && suggestionsComp }
                <div className='srp-header'>
                    <Tabs className='srp-tabs' activeTab={activeIndex} theme='light'>
                        <Tabs.List allowScrollButtonsMobile>
                            {
                                Array.isArray(tabs) && tabs.reduce((allTabs, tab, idx) => {
                                    const { title, gtmCategory, gtmId, gtmValue } = ( tab && tab.tab ) || {};
                                    if(title){
                                        allTabs.push(
                                            <div key={idx} onClickCapture={() => onSwitchTabs(idx)}>
                                                <Tabs.Tab
                                                    value={idx}
                                                    label={title}
                                                    gtmCategory={gtmCategory}
                                                    gtmId={gtmId}
                                                    gtmValue={gtmValue}
                                                />
                                            </div>
                                        );
                                    }

                                    return allTabs;
                                }, [])
                            }
                        </Tabs.List>
                    </Tabs>
                </div>
                { !suggestionsAreValid && suggestionsComp }
                {/* <div className='srp-suggestions-and-categories-container'>
                    <div className='srp-suggestion-and-categories'>
                        <SearchPageSuggestion {...props} zeroResults={zeroResults}/>
                        {
                            zeroResults && <SearchProductCategoryTiles searchKey={searchKey} type={tabType || type}/>
                        }
                    </div>
                </div> */}
            </div>
        </div>
    )
});
